import Constant from '@/const';
import axios from 'axios';

const postProcedure = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/master/procedure`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postProcedure;
